import { Component, Inject, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  public title = 'app';
  public logged = false;  
 
  public constructor(    
  ){
    console.log(environment.apiURL);
  }

 
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts